import { CreationToolSourceFile } from '../../types'
import { SourceEditorEdits } from './types'

type CaptionPosition = {
    x: number
    y: number
    maxWidth: number
}

type PreviewDimensions = {
    width: number
    height: number
}

export const getDefaultCaptionPosition = (
    source: CreationToolSourceFile,
    edits?: SourceEditorEdits
): CaptionPosition => {
    if (edits && edits.crop) {
        return {
            x: Math.round(edits.crop.x + edits.crop.width / 2),
            y: Math.round(edits.crop.y + edits.crop.height * 0.9),
            maxWidth: Math.round(edits.crop.width * 0.9),
        }
    }

    return {
        x: Math.round(source.width / 2),
        y: Math.round(source.height * 0.9),
        maxWidth: Math.round(source.width * 0.9),
    }
}

export const getPreviewDimensions = (aspectRatio: number, maxWidth: number, maxHeight: number): PreviewDimensions => {
    let width = maxWidth
    let height = Math.round(width / aspectRatio)

    if (height > maxHeight) {
        height = maxHeight
        width = Math.round(height * aspectRatio)
    }

    return { width, height }
}
